import React from "react";
import { RCCGrid, RCCIcon, RCCInput, RCCTooltip } from "react-common-components";
import DateTimePicker from "src/components/DateTimePicker";
import LovRiskClassification from "src/components/Lov/RiskClassification";
import LovUsers from "src/components/Lov/Users";
import Select from "src/components/Select";
import Title from "src/components/Title";
import { useAuth } from "src/context/Auth/context";
import { useTranslation } from "src/context/Translations/context";
import { CheckImpact, CheckProbability, CheckQuadrant, RisksSituation } from "../../interface";
import { IFormSimplifiedFields } from "./interface";

const FormSimplifiedFields: React.FC<IFormSimplifiedFields> = ({
	selectedRisk,
	isAdd,
	controlAddOrChange,
	errorsAddOrChange,
	registerAddOrChange
}) => {

	const { translate } = useTranslation();
	const { user } = useAuth();

	return (

		<RCCGrid
			container
			item
			xs={12}
			justifyContent="center"
		>
			<RCCGrid
				container
				item
				xs={10}
			>
				<Title color="purple" size="md">
					{translate("Dados Gerais")}
				</Title>
				<hr />
				<RCCGrid
					container
					item
					direction="column"
					alignItems="center"
					xs={12}
					justifyContent="center"
				>
						
					<RCCGrid
						container
						item
						xs={12}
					>
						<RCCGrid
							container
							item				
						>
							<RCCInput 
								label={translate("Título")} 
								name="rib001Titulo" 
								defaultValue={selectedRisk.rib001Titulo} 
								error={errorsAddOrChange.rib001Titulo}
								register={registerAddOrChange}
								maxLength={60}
								required
							/>
						</RCCGrid>
						<RCCGrid
							container
							item
							sm={12}
							alignItems="center"
						>
	
							<RCCGrid
								container
								item
								xs={12}
								sm={6}
								styleInline="@media (min-width: 600px){padding-right: 4px;}"
							>
								<DateTimePicker 
									type="datePicker"
									label={translate("Data")}
									name="rib001Data"
									control={controlAddOrChange}
									defaultValue={selectedRisk.rib001Data ? selectedRisk.rib001Data : new Date()}
									error={errorsAddOrChange.rib001Data}
									required
								/>
							</RCCGrid>
							<RCCGrid
								container
								item
								xs={12}
								sm={6}
								styleInline="@media (min-width: 600px){padding-left: 4px;}"
							>
								<Select 
									control={controlAddOrChange}
									name="rib001Situacao" 
									options={[	
										{
											value: RisksSituation.OPEN.toString(),
											label: translate("Aberto")
										},{
											value: RisksSituation.FINALY.toString(),
											label: translate("Finalizado")
										},
										{
											value: RisksSituation.CANCELED.toString(),
											label: translate("Cancelado")
										}
									]} 

									defaultValue={selectedRisk.rib001Situacao ? selectedRisk.rib001Situacao.toString() : `${RisksSituation.OPEN}`}
									error={errorsAddOrChange.rib001Situacao}
									disabled={isAdd}
									label={translate("Situação")}
									submit="value"
									required
								/>
							</RCCGrid>										
							<RCCGrid 
								container
								item
								xs={12}
								direction="row"
								justifyContent="space-between"
							>
								<LovUsers 
									control={controlAddOrChange}
									name="rib001Efa005Id"
									label={translate("Responsável")}
									defaultValue={selectedRisk.eftba005 ? {
										value: selectedRisk.rib001Efa005Id,
										label:  selectedRisk.eftba005.efa005Nome
									}: selectedRisk.rib001Efa005Id ?? `${user.efa005Id}`}
									error={errorsAddOrChange.rib001Efa005Id}
									required
								/>
	
											
							</RCCGrid>
							<RCCGrid 
								container
								item
								xs={12}
								direction="row"
								justifyContent="space-between"
							>
								<RCCGrid
									container
									item
									xs={12}
									sm={6}
									styleInline="@media (min-width: 600px){padding-right: 4px;}"
								>
									<RCCGrid
										container
										item	
									>
										<Select 
											control={controlAddOrChange}
											name="rib001Quadrante" 
											options={[{
												value: CheckQuadrant.OPPORTUNITY.toString(),
												label: translate("Oportunidade")
											}, {
												value: CheckQuadrant.THREAT.toString(),
												label: translate("Ameaça")
											}]} 
											label={translate("Tipo")}
											defaultValue={selectedRisk.rib001Quadrante ? selectedRisk.rib001Quadrante.toString() :CheckQuadrant.OPPORTUNITY.toString()}
											error={errorsAddOrChange.rib001Quadrante}
											required
										/>
									</RCCGrid>	
			
								</RCCGrid>
								<RCCGrid
									container
									item
									xs={12}
									sm={6}
									styleInline="@media (min-width: 600px){padding-left: 4px;}"
								>
			
									<LovRiskClassification 
										control={controlAddOrChange}
										name="rib001Ria001Id" 
										label={translate("Classificação")}
										defaultValue={selectedRisk.rib001Ria001Id ? selectedRisk.rib001Ria001Id.toString() : ""}
										error={errorsAddOrChange.rib001Ria001Id}
										isCreatable
										required
									/>
								</RCCGrid>	
							</RCCGrid>	
							<RCCGrid 
								container
								item
								xs={12}
								direction="row"
								justifyContent="space-between"
							>
								<RCCGrid
									container
									item
									xs={12}
									sm={6}
									alignItems="baseline"
									justifyContent="space-between"
								>
	
									<RCCGrid
										container
										item
										styleInline="@media (min-width: 600px){padding-right: 4px;}"
										style={{width: isAdd ? "" : "calc(100% - 30px)"}}
									>	
										<Select 
											control={controlAddOrChange}
											name="rib001Probabilidade" 
											options={[
												{
													value: CheckProbability.VERY_HIGH.toString(),
													label: translate("Muito alto")
												},{
													value: CheckProbability.HIGH.toString(),
													label: translate("Alto")
												},
												{
													value: CheckProbability.MODERATE.toString(),
													label: translate("Moderado")
												},
												{
													value: CheckProbability.LOW.toString(),
													label: translate("Baixo")
												},{
													value: CheckProbability.VERY_LOW.toString(),
													label: translate("Muito baixo")
												}
											]} 
											label={translate("Probabilidade")}
											error={errorsAddOrChange.rib001Probabilidade}
											defaultValue={selectedRisk.rib001Probabilidade ? selectedRisk.rib001Probabilidade.toString() : CheckProbability.VERY_LOW.toString()}
											required
											disabled={!isAdd}
										/>
	
									</RCCGrid>
	
									<RCCGrid
										container
										item
										justifyContent="center"
										styleInline="@media (min-width: 600px){padding-right: 4px;}"
										style={{ width: isAdd ? "" : "30px" }}
									>
										{!isAdd && (
													
											<RCCTooltip
												color="grey"
												text={translate("Alteração permitida apenas na análise de risco")}
											>
												<RCCIcon 
																
													name="infoCircle"
												/>
											</RCCTooltip>
										)}
									</RCCGrid>
												
												
								</RCCGrid>
								<RCCGrid
									container	
									item
									xs={12}
									sm={6}
									styleInline="@media (min-width: 600px){padding-left: 4px;}"
									alignItems="baseline"
								>
									<RCCGrid
										container
										item
										justifyContent="center"
										style={{width: isAdd ? "" : "calc(100% - 30px)"}}
									>
										<Select 
											control={controlAddOrChange}
											name="rib001Impacto" 
											options={[	
												{
													value: CheckImpact.VERY_HIGH.toString(),
													label: translate("Muito alto")
												},{
													value: CheckImpact.HIGH.toString(),
													label: translate("Alto")
												},
												{
													value: CheckImpact.MODERATE.toString(),
													label: translate("Moderado")
												},
												{
													value: CheckImpact.LOW.toString(),
													label: translate("Baixo")
												},{
													value: CheckImpact.VERY_LOW.toString(),
													label: translate("Muito baixo")
												}
											]} 
											label={translate("Impacto")}
											defaultValue={selectedRisk.rib001Impacto ? selectedRisk.rib001Impacto.toString() : CheckImpact.VERY_LOW.toString()}
											required
											submit="value"
											error={errorsAddOrChange.rib001Impacto}
											disabled={!isAdd}
										/>
	
									</RCCGrid>
									<RCCGrid
										container
										item
										justifyContent="center"
										alignItems="center"
										style={{ width: "30px" }}
									>
	
										{!isAdd && (
											<RCCGrid
												container
												item
												justifyContent="center"
											>
												<RCCTooltip
													color="grey"
													text={translate("Alteração permitida apenas na análise de risco")}
												>
													<RCCIcon 
														name="infoCircle"
													/>
												</RCCTooltip>
											</RCCGrid>
										)}
									</RCCGrid>
								</RCCGrid>
							</RCCGrid>	
						</RCCGrid>
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</RCCGrid>
	);

}
;

export default FormSimplifiedFields;
